<template>
  <div>
    <page-title value="延長保育日誌"></page-title>

    <v-card variant="flat" class="mt-6 pa-2" color="grey-lighten-5">
      <v-container>
        <v-row align="center">
          <v-col cols="4">
            <v-text-field
              v-model="searchValue.from"
              label="開始日"
              hide-details
              variant="outlined"
              density="compact"
              type="date"
              clearable
              :disabled="isLoading"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="searchValue.to"
              label="終了日"
              hide-details
              variant="outlined"
              density="compact"
              type="date"
              clearable
              :disabled="isLoading"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn
              @click="listDiary"
              color="primary"
              large
              variant="flat"
              :loading="isLoading"
              >検索</v-btn
            >
          </v-col>
          <v-spacer />
        </v-row>
      </v-container>
    </v-card>

    <div class="d-flex mt-8 mb-4">
      <h3>検索結果 {{ diaries.totalItemsCount }}件</h3>
      <v-spacer />
      <v-btn color="primary" variant="flat" to="/nursery-hours-diary/edit">
        <v-icon start>mdi-plus</v-icon>
        新規作成
      </v-btn>
    </div>

    <v-card
      v-for="(item, i) in diaries.diaries"
      :key="i"
      class="pa-3 my-2"
      variant="outlined"
      style="border-color: #e0e0e0;"
    >
      <div class="d-flex">
        <div class="d-flex align-center">
          <div>
            <h4>{{ item.date }}</h4>
            <!-- <h4>{{ formatDate(item.createdAt)}}</h4> -->
          </div>
        </div>

        <v-spacer />

        <!-- label -->
        <div class="d-flex align-center mr-6">
          <v-chip
            v-if="item.approvedBy.chief && item.approvedBy.chief != -1"
            color="primary"
            class="mx-1"
            label
          >
            <v-icon start>mdi-check</v-icon>
            主任
          </v-chip>
          <v-chip
            v-if="item.approvedBy.director && item.approvedBy.director != -1"
            color="primary"
            class="mx-1"
            label
          >
            <v-icon start>mdi-check</v-icon>
            施設長
          </v-chip>
          <v-chip
            v-if="item.status === 'applied'"
            color="primary"
            variant="outlined"
            class="mx-1"
            >申請済み</v-chip
          >
          <v-chip v-if="item.status == 'draft'" variant="outlined" class="mx-1" style="border-color: #e0e0e0;"
            >下書き
          </v-chip>
        </div>

        <div class="d-flex">
          <v-btn
            @click="clickEdit(item.nurseryHoursDiaryId, item.date)"
            color="primary"
            variant="flat"
            :disabled="isLoading"
            >詳細</v-btn
          >
        </div>
      </div>
    </v-card>
  </div>
</template>

<script lang="ts">
import PageTitle from "@/components/atoms/PageTitle.vue";
import LocalDataService from "@/service/LocalDataService";
import { nurseryHoursDiaryModule } from "@/store/dataModules/nurseryHoursDiaryModule";
import { NurseryHoursDiaryResponse } from "chaild-api/lib";
import dayjs from "dayjs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "NurseryHoursDiaries",

  components: {
    PageTitle,
  },

  async mounted() {
    const nurseryHoursDiaryFrom = sessionStorage.getItem('nurseryHoursDiaryFrom');
    const nurseryHoursDiaryTo = sessionStorage.getItem('nurseryHoursDiaryTo');

    if (nurseryHoursDiaryFrom) this.searchValue.from = nurseryHoursDiaryFrom;
    if (nurseryHoursDiaryTo) this.searchValue.to = nurseryHoursDiaryTo;

    await this.listDiary();
  },

  data() {
    return {
      isLoading: false,
      searchValue: {
        limit: 100,
        skip: 0,
        to: "",
        from: "",
      },
    };
  },

  computed: {
    diaries: function (): NurseryHoursDiaryResponse[] {
      return nurseryHoursDiaryModule.diaries;
    },
  },

  methods: {
    async listDiary() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        if (this.searchValue.from) sessionStorage.setItem('nurseryHoursDiaryFrom', this.searchValue.from); else sessionStorage.setItem('nurseryHoursDiaryFrom', '');
        if (this.searchValue.to) sessionStorage.setItem('nurseryHoursDiaryTo', this.searchValue.to); else sessionStorage.setItem('nurseryHoursDiaryTo', '');
        await nurseryHoursDiaryModule.listDiary({
          nurseryId: String(nurseryId),
          ...this.searchValue,
        });
      }
      this.isLoading = false;
    },
    formatDate(date: string): string {
      if (date) {
        return dayjs(date).format("YYYY-MM-DD");
      }
      return "";
    },
    clickEdit(id: string, date: string) {
      this.$router.push({
        path: "/nursery-hours-diary/edit",
        query: {
          diaryId: id,
          date: this.formatDate(date),
        },
      });
    },
  },
});
</script>
